import { RadioButtonGroupInput } from "react-admin";
import React from "react";

const YesOrNoInput = (props) => (
  <RadioButtonGroupInput
    {...props}
    choices={[
      { id: true, name: "app.label.yes" },
      { id: false, name: "app.label.no" },
    ]}
  />
);
export default YesOrNoInput;
